import { SwiperSlide } from "swiper/react";
import { BaseCarousel } from "../BaseCarousel";
import { OptimizedImage } from "@shared/components/OptimizedImage";

interface ProductImage {
  url: string;
  publicId: string;
  _id: string;
}

interface ProductImageCarouselProps {
  images: ProductImage[];
  productName: string;
  className?: string;
}

export function ProductImageCarousel({
  images,
  productName,
  className = "",
}: ProductImageCarouselProps) {
  const defaultImage =
    "https://res.cloudinary.com/dq8ig7aly/image/upload/v1749660976/no-image_lbt2of.jpg";

  // Si no hay imágenes, mostrar imagen por defecto
  const displayImages =
    images.length > 0
      ? images
      : [{ url: defaultImage, publicId: "", _id: "default" }];

  return (
    <div className={`${className}`}>
      <BaseCarousel
        spaceBetween={0}
        slidesPerView={1}
        navigation={displayImages.length > 1}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        loop={displayImages.length > 1}
        autoplay={
          displayImages.length > 1
            ? {
                delay: 5000,
                disableOnInteraction: false,
              }
            : false
        }
        className="product-image-carousel"
        style={{
          backgroundColor: "transparent",
          height: "100%",
          width: "100%",
        }}
      >
        {displayImages.map((image, index) => (
          <SwiperSlide key={image._id || index}>
            <div className="aspect-square bg-white rounded-lg p-4 shadow-sm">
              <OptimizedImage
                src={image.url}
                alt={`${productName} - Imagen ${index + 1}`}
                width={500}
                height={500}
                quality={95}
                format="webp"
                className="w-full h-full object-contain"
              />
            </div>
          </SwiperSlide>
        ))}
      </BaseCarousel>
    </div>
  );
}
